import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import Dot from 'app/React/InspirationUniverse/Dot'
import classNames from 'classnames'
import debounce from 'lodash/debounce'

SwiperCore.use([Navigation]);

export default function ProductImageSlider ({
  gallery = [],
  imageOne,
  imageTwo
}) {

  const [slides, setSlides] = React.useState(gallery)
  const [prependSlides, setPrependSlides] = React.useState([imageOne, imageTwo].filter(obj => obj !== null))
  const [slidesAdded, setSlidesAdded] = React.useState(false)

  const slideCountClass = "mtt-iu-product__slider-wrapper--slide-count-" + slides.length
  const prependSlideCountClass = "mtt-iu-product__slider-wrapper--prepend-slides-count-" + prependSlides.length

  const handleSlides = debounce(() => {
    if (getScreenWidth() < 1100) {
      if (!slidesAdded) {
        const newSlides = [...prependSlides, ...slides]
        setSlides(newSlides)
        setSlidesAdded(true)
      }
    } else {
      if (slidesAdded) {
        const newSlides = [...slides]
        setSlides(newSlides.slice(prependSlides.length))
        setSlidesAdded(false)
      }
    }
  }, 300)

  const getScreenWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  if (slides.length === 0) {
    return null
  }

  return (
    <div className={classNames("mtt-iu-product__slider-wrapper", {
      [slideCountClass]: true,
      [prependSlideCountClass]: true
    })}>
      <Swiper
        className="mtt-iu-product__slider"
        spaceBetween={16}
        slidesPerView={'auto'}
        speed={800}
        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
        onResize={handleSlides}
        onInit={handleSlides}
        watchOverflow={true}
      >
        <div className="swiper-button-prev mtt-iu-product__slide-button mtt-iu-product__slide-button--prev"/>
        <div className="swiper-button-next mtt-iu-product__slide-button mtt-iu-product__slide-button--next"/>
        {slides.filter(slide => slide?.image).map((slide, index) => {
          return (
            <SwiperSlide
              key={index}
              className={classNames("mtt-iu-product__slide object-fit", {
                ["mtt-iu-product__slide--" + slide.size]: true
              })}
            >
              <img src={slide?.image?.src} alt={slide?.image?.alt}/>
              {slide?.markers?.length > 0 && slide.markers.map((marker, index) => {
                return <Dot
                  key={index}
                  x={marker?.percentX}
                  y={marker?.percentY}
                  title={marker?.title}
                  text={marker?.text}
                />
              })}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}
